import React from "react";
import {
  Button,
  Form,
  Col,
  Popover,
  OverlayTrigger,
  Row,
} from "react-bootstrap";
import Crops from "../wdpMap/Crops";
import { useSelector } from "react-redux";
import { EMPTY } from "../../configurations/Constants";

function CropDetailsList({
  crop,
  cropIndex,
  indexValue,
  hasAccessValue,
  handleCropNameChange,
  handleRemoveCropEntries,
  handleSavedRemoveCropEntries,
}) {
  const cropName = crop.crop;
  const tillage = crop.tillage;
  const cropId = crop.id;
  const TillagesValue = useSelector((state) => state.field.tillages);

  const getTillageList = () => {
    if (TillagesValue.length === 0) return [];
    return TillagesValue.map((item) => (
      <option key={item.value} value={item.value}>
        {item.value}
      </option>
    ));
  };

  return (
    <Row className="crop-row-width">
      <Form.Group
        controlId={"crop" + cropIndex}
        as={Col}
        md="5"
        className="me-6 mb-0"
      >
        <Form.Label>Crop</Form.Label>
        <Crops
          cropName={cropName}
          handleCropNameChange={handleCropNameChange}
          index={cropIndex}
          Disabled={!hasAccessValue}
        ></Crops>
      </Form.Group>
      <Form.Group
        controlId={"tillage" + cropIndex}
        as={Col}
        md="3"
        className="mb-0"
      >
        <Form.Label>
          {indexValue === 1 ? (
            <div className="d-flex align-items-center">
              {" "}
              Tillage
              <h3 className="s3-header-message">
                <OverlayTrigger
                  trigger="click"
                  rootClose
                  placement="bottom"
                  overlay={
                    <Popover id="info-popover">
                      <Popover.Body>
                        <p>
                          <b>CTill:</b> Conventional Till
                        </p>
                        <p>
                          <b>MTill:</b> Minimum Till
                        </p>
                        <p>
                          <b>NTill:</b> No Till
                        </p>
                        <p>
                          <b>STill:</b> Strip Till
                        </p>
                      </Popover.Body>
                    </Popover>
                  }
                >
                  <Button
                    variant="secondary"
                    className="info-button info-icon-crop-tab fa fa-info-circle"
                  ></Button>
                </OverlayTrigger>
              </h3>
            </div>
          ) : (
            "Tillage "
          )}
        </Form.Label>
        <Form.Select
          size="sm"
          name="tillage"
          value={tillage}
          required
          disabled={!hasAccessValue}
          onChange={handleCropNameChange(cropIndex)}
        >
          {getTillageList()}
        </Form.Select>
      </Form.Group>
      <Form.Group
        controlId={"acres" + cropIndex}
        as={Col}
        md="3"
        className="mb-0"
      >
        <Form.Label>Acres</Form.Label>
        <Form.Control
          type="text"
          value={crop.acres}
          size="sm"
          name="acres"
          pattern="^[0-9]*([.][0-9]{1,2})?$"
          required
          disabled={!hasAccessValue}
          onChange={handleCropNameChange(cropIndex)}
        />
        <Form.Control.Feedback type="invalid">
          {crop.acres === EMPTY
            ? "Enter acres"
            : isNaN(crop.acres)
            ? "Only numbers"
            : crop.acres < 0 || crop.acres.toString().indexOf("+") > -1
            ? "Only numbers"
            : "2 Decimals only"}
        </Form.Control.Feedback>
      </Form.Group>
      {!crop.user_field_id ? (
        <Form.Group as={Col} md="1" className="mb-0">
          <Button
            variant="link"
            style={{ marginTop: "20px" }}
            disabled={!hasAccessValue}
          >
            <i
              className="fa fa-minus-circle"
              onClick={handleRemoveCropEntries(cropIndex, cropName)}
            />
          </Button>
        </Form.Group>
      ) : (
        <Form.Group as={Col} md="1" className="mb-0">
          <Button
            variant="link"
            style={{ marginTop: "20px" }}
            disabled={!hasAccessValue}
          >
            <i
              className="fa fa-minus-circle"
              onClick={handleSavedRemoveCropEntries(
                cropIndex,
                cropName,
                cropId
              )}
            />
          </Button>
        </Form.Group>
      )}
    </Row>
  );
}

export default CropDetailsList;
